import {useState, useEffect, useRef} from 'react';
import styles from '@/components/filters/FilterBase.module.css';
import {motion, AnimatePresence} from "framer-motion";
import {FaCaretDown} from 'react-icons/fa';

const variants = {
  open: {y: 0, transition: {duration: 0.5}},
  closed: {y: '5%'}
}

const FilterBase = ({children, buttonName}) => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef();

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (!containerRef.current.contains(event.target)) {
        if (isOpen) setIsOpen(false);
      }
    };
    window.addEventListener('click', handleOutsideClick);
    return () => window.removeEventListener('click', handleOutsideClick);
  }, [isOpen]);

  const handleFilterButtonClick = (e) => {
    e.stopPropagation(); // Stop the click event from reaching the window
    setIsOpen((prevOpen) => !prevOpen); // Toggle isOpen on each click
  };

  return (
    <div className={styles.filterContainer} ref={containerRef}>
      <div
        className={`${styles.filterButton} ${isOpen ? styles.active : ''}`}
        onClick={handleFilterButtonClick}
      >
        <div className={styles.buttonText}>{buttonName}</div>
        <FaCaretDown/>
      </div>

      {isOpen && (
        <motion.div initial="closed" animate="open" exit="closed" variants={variants}>
          {typeof children === 'function' ? children({ close: () => setIsOpen(false) }) : children}
        </motion.div>
      )}

    </div>
  )
}


export default FilterBase
